import moment from 'moment';
import { calcTime } from 'features/overtime/uploadExcell/UploadExcell';
import { PICKER_TIME_MASK } from 'shared/constants';
import { NOT_PROVIDED_DATE_RVD, NOT_PROVIDED_TIME_RVD } from 'shared/constants/rvd';
import {
  NOT_PROVIDED_DATE_OVERTIME,
  NOT_PROVIDED_TIME_OVERTIME,
  WORK_TIME_OVER_MESSAGE_OVERTIME,
} from 'shared/constants/overtime';
import { notification } from 'antd';
import { checkPasswordNotSpaceNotCyrillic } from './string';

export const validateLoginPassword = (_: any, value: string) =>
  checkPasswordNotSpaceNotCyrillic(value)
    ? Promise.resolve()
    : Promise.reject(
        'Пароль должен быть от 16 символов, содержать заглавные и строчные буквы, цифры и, как минимум, один символ из перечисленных @#$&*%',
      );

export const validateExcelDataOvertime = (data: (string | number)[][], line: number) => {
  if (!data[line][6] || !data[line][7]) {
    throw new Error(NOT_PROVIDED_TIME_OVERTIME);
  }

  // Убрана проверка т.к. она не должна работать для локального персонала
  // const START_TIME = moment(calcTime(data[line][6]), PICKER_TIME_MASK);
  // const END_TIME = moment(calcTime(data[line][7]), PICKER_TIME_MASK);
  // const WORK_TIME = END_TIME.diff(START_TIME) / 1000 / 60 / 60;
  // if (WORK_TIME > 4) {
  //   throw new Error(WORK_TIME_OVER_MESSAGE_OVERTIME);
  // }

  if (!data[line][5]) {
    throw new Error(NOT_PROVIDED_DATE_OVERTIME);
  }
};

export const validateExcelDataRvd = (data: (string | number)[][], line: number) => {
  const startTime = calcTime(data[line][8]);
  const endTime = calcTime(data[line][9]);

  if (!data[line][7]) {
    throw new Error(NOT_PROVIDED_DATE_RVD);
  }
  if (!data[line][9] || !data[line][8]) {
    throw new Error(NOT_PROVIDED_TIME_RVD);
  }
};

export const validateBreakTime = (start?: string, end?: string): boolean => {
  if (!start && !end) {
    return true;
  }
  if (!start || !end) {
    return false;
  }
  const breakTime = Math.ceil(moment(end, PICKER_TIME_MASK).diff(moment(start, PICKER_TIME_MASK)) / 1000 / 60);

  if (breakTime < 5) {
    notification.warning({ message: 'Перерыв не должен быть меньше 5 минут' });
    return false;
  }
  return true;
};
